export const ON_LOAD = 'onLoad';
export const ON_FOCUS = 'onFocus';
export const ON_EXPAND = 'onExpand';
